export const document = {
  add_btn: 'Tambahkan dokumen',
  field: {
    document: 'Dokumen'
  },
  form: {
    title: 'Unggah dokumen',
    text:
      'Unggah pindaian berwarna Ktp dan NPWP Anda.<br> ' +
      'Anda dapat mengunggah file dalam format berikut: .jpg, .jpeg, .png, .pdf. <br>. <br>' +
      'Maximum upload file adalah 10 MB. <br>' +
      'Anda dapat mengunggah hingga lima dokumen sekaligus. <br> ' +
      'Verifikasi dokumen membutuhkan waktu 1-3 hari kerja.',
    save_file_btn: 'Simpan files',
    selected_file_btn: 'Pilih files'
  },
  error: {
    max_size: '{filename}  melebihi ukuran file upload maksimum'
  },
  status: {
    new: 'Moderasi',
    approved: 'Approved',
    rejected: 'Ditolak'
  }
};
